import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IGetFlightExcelRepoResponse = IRepoResponse<200, Blob> | IRepoResponse<400 | 500, string>;

export type IGetFlightExcelRepo = IRepo<[{ flightId: number | string; partnerId?: number }], IGetFlightExcelRepoResponse>;

export const GetFlightExcelRepoType = Symbol.for('GetFlightExcelRepo');

@bind(GetFlightExcelRepoType)
export class GetFlightExcelRepo implements IGetFlightExcelRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ flightId, partnerId }) {
    try {
      const result = await this.httpClient.get({
        url: urlMaker('/api/admin/flights/export', {
          flight_id: flightId,
          partner_id: partnerId,
        }),
      });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: await result.blob(),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);

      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
